document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.custom-collection-buttons button');
  const containers = document.querySelectorAll('.custom-collection-container');

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      // Remove active classes
      buttons.forEach((btn) => btn.classList.remove('custom-active'));
      containers.forEach((container) => container.classList.remove('custom-active'));

      // Add active class to clicked button and its corresponding container
      button.classList.add('custom-active');
      const collectionId = `collection-${button.dataset.collection}`;
      const collectionContainer = document.getElementById(collectionId);
      if (collectionContainer) {
        collectionContainer.classList.add('custom-active');
      }
    });
  });
});
